
export class PrinterHelpertSetting {
    id: number = 0;
    side: string = 'right';
    userId: number = 0;
    hasRamp: boolean = false;
    cutFront: boolean = false;
    
    setSide = (side: string) =>{
        this.side = side;
    }

    setUserId  = (id: number)=>{
        this.userId = id;
    }

    toJson() {
        return {
            userId: this.userId,
            Side: this.side,
            HasRamp: this.hasRamp,
            CutFront: this.cutFront,
        };
    }
}
